<mijn-login-template [showExtraContentCard]="false">
    <klant-login-error [context]="context" (actionClicked)="doAction()"></klant-login-error>
</mijn-login-template>
